import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div
      id='libraryEmploymentFolderPreview'
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p id='libraryEmploymentFolderPreviewText'>
        This is where you will find your employment documents, including contracts, policies and
        letters. Any employment documents you upload or create on the platform will be stored here.
      </p>
    </div>
  );
};

export default Preview;
